import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-institutional-dist',
  templateUrl: './institutional-dist.component.html',
  styleUrls: ['./institutional-dist.component.scss']
})
export class InstitutionalDistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
